import { Link } from 'react-router-dom';

import Button from '../../components/Button/Button';
import SaveGameControl from '../../components/SaveGameControl/SaveGameControl';
import RollPowerLaunch from '../../components/RollPowerLaunch/RollPowerLaunch';
import { playSound } from '../../utils/utils';

export { ROLL_CHARGE_MS } from '../../components/RollPowerLaunch/RollPowerLaunch';

const MultiPlayerPreRoll = ({ addNewRolls, playerNamesState }) => (
  <RollPowerLaunch onRoll={addNewRolls} to="/multi/post-roll">
    {(isCharging) => (
      <div className="optionsPreRoll">
        <Link to="/multi/player-names" tabIndex={isCharging ? -1 : undefined}>
          <Button
            title="edit plAyers"
            type="smallSquare editPlayers"
            disabled={isCharging}
            handleClick={() => playSound('/sounds/go-back.mp3')}
          />
        </Link>
        <Link to="/multi/stats" tabIndex={isCharging ? -1 : undefined}>
          <Button
            title="stAts"
            type="smallSquare stats"
            disabled={isCharging}
            handleClick={() => playSound('/sounds/menu-select.mp3')}
          />
        </Link>
        <SaveGameControl
          playerNamesState={playerNamesState}
          disabled={isCharging}
        />
      </div>
    )}
  </RollPowerLaunch>
);

export default MultiPlayerPreRoll;
